module.exports = __webpack_public_path__ + "static/media/samuel_nicolle_3.69fa0a04.jpg";